module.exports = __webpack_public_path__ + "static/media/204.761b5f6c.jpg";